module.exports = __webpack_public_path__ + "static/media/Sempione - GR Green - Ind.Blue_Peri.c93a1bda.jpg";